// The interface language, applied LIVE (the Mac asks for a restart; a web page can do better).
// Strings are resolved at render time, so the app re-renders from the top: App keys the
// workspace by `useUiLanguage()`, which remounts it in the new language — the URL keeps the
// reader where they were and the local-first store repaints it on the first frame.
import { useEffect, useState } from 'react';
import { data } from '../../../bridge/client';
import { language, setLanguage, storeLanguageChoice, systemLanguage, type Language, type LanguageChoice } from '../../../i18n/i18n';

const EVENT = 'satori:language';

export function applyLanguageChoice(choice: LanguageChoice): void {
  storeLanguageChoice(choice);
  const lang: Language = choice === 'system' ? systemLanguage() : choice;
  setLanguage(lang);
  // The worker writes some sentences itself (browser notifications, system notices).
  data.call('setLanguage', lang).catch(() => undefined);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: lang }));
}

/** The language the UI is drawn in right now; changes when `applyLanguageChoice` runs. */
export function useUiLanguage(): Language {
  const [lang, setLang] = useState<Language>(language);
  useEffect(() => {
    const on = () => setLang(language());
    window.addEventListener(EVENT, on);
    return () => window.removeEventListener(EVENT, on);
  }, []);
  return lang;
}
